// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { OptionGroup } from "../OptionGroup"
import { useI18n } from "@/i18n"
import type { AnswerDraft } from "../types"

interface Props {
  value: AnswerDraft
  onChange: (patch: AnswerDraft) => void
}

/** Step 8 (wire) — cooking skill + enjoyment. */
export function Step8Cooking({ value, onChange }: Props) {
  const { t } = useI18n()
  const cookingSkill = (value.cookingSkill as string | undefined) ?? null
  const cookingEnjoyment = (value.cookingEnjoyment as string | undefined) ?? null

  return (
    <div className="flex flex-col gap-5">
      <OptionGroup
        legend={t("onboarding.step8.title")}
        columns={3}
        value={cookingSkill}
        onChange={next => onChange({ cookingSkill: next, cookingEnjoyment })}
        options={[
          {
            value: "beginner",
            label: t("onboarding.step8.beginner"),
            sublabel: t("onboarding.step8.beginnerSub"),
          },
          {
            value: "intermediate",
            label: t("onboarding.step8.intermediate"),
            sublabel: t("onboarding.step8.intermediateSub"),
          },
          {
            value: "advanced",
            label: t("onboarding.step8.advanced"),
            sublabel: t("onboarding.step8.advancedSub"),
          },
        ]}
      />
      <OptionGroup
        legend={t("onboarding.step8.title")}
        columns={2}
        value={cookingEnjoyment}
        onChange={next => onChange({ cookingSkill, cookingEnjoyment: next })}
        options={[
          { value: "high", label: t("onboarding.step8.enjoymentHigh") },
          { value: "low", label: t("onboarding.step8.enjoymentLow") },
        ]}
      />
    </div>
  )
}
